import { SettingComponent } from "../../components";

export default function DictionarySettingPage() {
  return <SettingComponent.DictionarySettingPage />;
}
